module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// ./~/crossfilter/index.js
// module id = 131
// module chunks = 0